<form>
  <label>{{ label }}</label>
  <div class="bciti-select-notification bciti-select-notification-input" (click)="toggleDropdown()" #dropreference>
    <ul>
      <li>{{ selected.name }} <span [ngClass]="dropdown.showing ? 'icon-caret-up' : 'icon-caret-down'" class="icon"></span></li>
    </ul>
    <app-form-select-user-cards-dropdown [reference]="dropreference" #dropdown>
      <div class="bciti-select-notification bciti-select-notification-dropdown no-margin">
        <ul>
          <ng-container *ngFor="let option of options">
            <li (click)="select(option)" *ngIf="option.id !== selected.id">
            {{ option.name }}
            </li>
          </ng-container>
          <ng-container *ngIf="useOptionNew">
            <li class="li-hr"><hr></li>
            <li class="bciti-select-notification-dropdown-add" (click)="new()">
              <span class="icon-plus"></span> {{ newLabel }}
            </li>
          </ng-container>
        </ul>
      </div>
    </app-form-select-user-cards-dropdown>
  </div>
</form>
